import { render, staticRenderFns } from "./PurchaseIngredientsTab.vue?vue&type=template&id=20de4720&scoped=true&"
import script from "./PurchaseIngredientsTab.vue?vue&type=script&lang=js&"
export * from "./PurchaseIngredientsTab.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseIngredientsTab.vue?vue&type=style&index=0&id=20de4720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20de4720",
  null
  
)

export default component.exports